export default __webpack_public_path__ + "static/media/apple_music.a7f98234.svg";